export const cubeFinish = 3.7;

export const boxExpandDuration = 0.75;
export const boxExpandStart = cubeFinish;
export const boxExpandFinish = cubeFinish + boxExpandDuration;
export const boxExpandBezier = [0.16, 1, 0.3, 1];

export const maskfadeStart = boxExpandFinish-0.1;
export const maskFadeDuration = 0.5;
export const maskFadeBezier = [0, 0.55, 0.45, 1];
export const maskFadeFinish = maskfadeStart+maskFadeDuration;


export const mobWiperStart = cubeFinish+0.75;
// export const wiperStart = (maskFadeFinish-0.2);
export const wiperDuration = 1.25;
// export const wiperEnd = wiperStart + wiperDuration;
export const wiperEnd = 5.638;
// export const wiperEnd = cubeFinish + 1;
export const maskUpStart = 2.8;
export const maskUpDuration = 1;
export const maskUpEnd = maskUpStart + maskUpDuration;
export const maskExpandDuration = 1.25;

export const clipperStart = 1000;

export const videoInStart = 4.7;
export const videoShrinkDuration = 1.25;
export const videoEndPoint = videoInStart + videoShrinkDuration

export const waitForLoaderMount = 0.5;
export const extVideoInStart = videoInStart - waitForLoaderMount;
export const extVideoEndPoint = videoEndPoint - waitForLoaderMount;